export enum FirebaseEmailActions {
  ResetPassword = "resetPassword",
  RecoverEmail = "recoverEmail",
  VerifyEmail = "verifyEmail"
}
